/* eslint-disable class-methods-use-this */
import axios from 'axios'

import { MasterDataResponse } from '../model/masterData.model'

export default class MasterDataService {
  constructor(private host: string) {}
  fetchMasterData({
    dealerId,
    subscriptionType,
  }: {
    dealerId: string
    subscriptionType: string
  }): Promise<MasterDataResponse> {
    return axios
      .get(`${this.host}/sales/v1/masmovil/master-data`, {
        params: {
          dealerId,
          subscriptionType,
        },
      })
      .then((response) => response.data)
  }
}
